import { CurrentRouteFallback } from "@/routes/routeFallbacks";

function PageAuthLoader() {
  return <CurrentRouteFallback />;
}

export default PageAuthLoader;
